import { Dashboard } from '@uppy/react';
import React, { useEffect, useState } from 'react';
import classes from './PostFormUppy.module.css';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import 'assets/custom-riza-plugin-styles/uppy.css';
import useUploadFiles from 'containers/Uppy/useUploadFiles';

const PostFormUppy = (props) => {
  const { uppyRef } = useUploadFiles('post', props.commentType, props.close);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!loading) setLoading(true);
  }, [loading]);

  const [title, setTitle] = useState(props.title);

  useEffect(() => {
    if (props.title === 'FilePicker' && title === 'Reorder') {
      // Reset when user taps "+" to add more photos from Reorder screen
      uppyRef.current.reset();
    }
    if (props.title !== title) setTitle(props.title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.title, title]);

  useEffect(() => {
    if (uppyRef.current) {
      uppyRef.current.setOptions({ closeAfterFinish: true });
      uppyRef.current.on('file-added', () => {
        if (props.showReorderOption === true) {
          props.toggleReorderer();
          props.handleUppyUploadStart();
        }
      });
      uppyRef.current.on('upload', () => {
        props.handleUppyUploadStart();
      });
      uppyRef.current.on('complete', () => {
        if (props.showReorderOption === false && props.title === 'FilePicker') props.toggleReorderer();
        props.handleUppyUploadCompletion();
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const uppyContainerClasses = [classes.UppyDashboardContainer];
  if (props.title !== 'Upload') uppyContainerClasses.push(classes.InitialScreen);
  if (props.shortWindow === true) uppyContainerClasses.push(classes.ShortWindow);

  if (props.commentForm === true) {
    uppyContainerClasses.push(classes.CommentForm);
  }
  return (
    <div className={uppyContainerClasses.join(' ')}>
      {uppyRef.current && (
        <Dashboard
          {...props}
          uppy={uppyRef.current}
          debug={false}
          thumbnailWidth={114}
          height={props.shortWindow === true ? 526 : 648}
          width={400}
          inline
          hideCancelButton
          trigger="#uppy-select-files"
          proudlyDisplayPoweredByUppy={false}
          showProgressDetails
          metaFields={[]}
          locale={{
            strings: {
              uploadComplete: 'Upload Succesful',
              xFilesSelected: { 0: '%{smart_count} Image Selected', 1: '%{smart_count} Images Selected' },
            },
          }}
        />
      )}
    </div>
  );
};

export default PostFormUppy;
